import type { Branding } from './api';

const TAMANHO_MAXIMO_LOGO = 400 * 1024;
const TIPOS_LOGO_ACEITOS = new Set(['image/png', 'image/jpeg', 'image/webp']);

export function validarArquivoLogo(arquivo: Pick<File, 'type' | 'size'>): string | null {
  if (!TIPOS_LOGO_ACEITOS.has(arquivo.type)) {
    return 'Use uma imagem PNG, JPG ou WebP.';
  }
  if (arquivo.size === 0 || arquivo.size > TAMANHO_MAXIMO_LOGO) {
    return 'A imagem deve ter até 400 KiB e não pode estar vazia.';
  }
  return null;
}

function corRgb(cor: string): [number, number, number] {
  const valor = Number.parseInt(cor.slice(1), 16);
  return [(valor >> 16) & 255, (valor >> 8) & 255, valor & 255];
}

function hex(rgb: [number, number, number]): string {
  return `#${rgb.map((canal) => Math.round(canal).toString(16).padStart(2, '0')).join('')}`;
}

function escurecer(cor: string, fator: number): string {
  const [vermelho, verde, azul] = corRgb(cor);
  return hex([vermelho * fator, verde * fator, azul * fator]);
}

function suavizar(cor: string): string {
  const [vermelho, verde, azul] = corRgb(cor);
  const suavizarCanal = (canal: number) => canal * 0.08 + 255 * 0.92;
  return hex([suavizarCanal(vermelho), suavizarCanal(verde), suavizarCanal(azul)]);
}

export function variaveisDaMarca(branding: Branding): Record<string, string> {
  const { corPrimaria, corAcento } = branding;
  return {
    '--marca': corPrimaria,
    '--marca-texto': corPrimaria,
    '--marca-forte': escurecer(corPrimaria, 0.82),
    '--marca-suave': suavizar(corPrimaria),
    '--acento': corAcento,
    '--gradiente': `linear-gradient(135deg, ${corPrimaria} 0%, ${corAcento} 100%)`,
    '--foco': corPrimaria,
  };
}

export function aplicarIdentidadeVisual(
  destino: Pick<CSSStyleDeclaration, 'setProperty'>,
  branding: Branding,
): void {
  for (const [propriedade, valor] of Object.entries(variaveisDaMarca(branding))) {
    destino.setProperty(propriedade, valor);
  }
}
